module.exports = __webpack_public_path__ + "static/media/remember_05.61c1547d.png";